import {useState} from "react";
import ErrorUtils from "src/utils/ErrorUtils";
import { utils, write } from 'xlsx';
import StringUtils from "src/utils/stringUtils";
import {downloadReport} from "src/components/reports/downloadReports/Utils";
import {getJEFieldsTableColumns} from "src/components/calculation-builder/configure-journals/Utils";

function prepareJournalLinesDataForExcel(data: Record<string, any>[], hasJeTagData: boolean): Record<string, any>[] {
    const columns = getJEFieldsTableColumns(hasJeTagData);
    return data.map((row: Record<string, any>) => {
        const formattedRow: Record<string, any> = {};
        columns.forEach(column => {
            const camelCaseColumn = StringUtils.convertCamelCaseToTitleCase(column);
            formattedRow[camelCaseColumn] = row[column];
        });
        return formattedRow;
    });
}

export function useJournalLinesExcelBasedDownload(sheetName: string, fileName: string, hasJeTagData: boolean) {
    const [downloadResult, setDownloadResult] = useState<string>('');
    const [downloadError, setDownloadError] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    const downloadJournalLinesReportExcel = (journalLinesToDownload: Record<string, any>[]) => {
        setLoading(true);
        setDownloadResult('');
        setDownloadError('');

        try {
            if (journalLinesToDownload.length > 0) {
                const formattedJournalLinesData = prepareJournalLinesDataForExcel(journalLinesToDownload, hasJeTagData);
                const workSheet = utils.json_to_sheet(formattedJournalLinesData);
                const workBook = utils.book_new();
                utils.book_append_sheet(workBook, workSheet, sheetName);
                const wbOut = write(workBook, { bookType: 'xlsx', type: 'base64' });
                downloadReport(fileName, wbOut);
                setDownloadResult('Success');
            } else {
                setDownloadResult('No records to download.');
            }
        } catch (error) {
            setDownloadError(ErrorUtils.getMessage(error));
        } finally {
            setLoading(false);
        }
    };

    return [downloadResult, loading, downloadError, downloadJournalLinesReportExcel] as const;
}
